import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRight, ChevronDown, Copy } from 'lucide-react';
import { LEVEL_LABELS, SavedPathway } from '../../../types/pathway';
import { moduleById } from '../../../data/skillModules';
import { formatHours, totalHours } from '../../../utils/pathwayMatching';
interface SavedPathwayRowProps {
  pathway: SavedPathway;
  expanded: boolean;
  onToggleExpand: () => void;
  onOpen: (pathway: SavedPathway) => void;
  onDuplicate: (pathway: SavedPathway) => void;
}
export function SavedPathwayRow({
  pathway,
  expanded,
  onToggleExpand,
  onOpen,
  onDuplicate
}: SavedPathwayRowProps) {
  return <>
      <tr className="border-b border-gray-100 transition-colors hover:bg-gray-50" data-id="element-1819" data-mp="18aa21ys109qh">
        <td className="px-3 py-4 sm:px-6" data-id="element-1820" data-mp="13d9xjsatrf1h">
          <button type="button" onClick={onToggleExpand} aria-expanded={expanded} className="flex items-start gap-2 text-left" data-id="element-1821" data-mp="20th0sipn3qzs">
            <ChevronDown size={16} aria-hidden="true" className={`mt-0.5 flex-shrink-0 text-gray-400 transition-transform ${expanded ? 'rotate-180' : ''}`} data-id="element-1822" data-mp="2zd5y9i9vo9jf" />
            <span data-id="element-1823" data-mp="2pmbcef0jnbyi">
              <span className="block text-sm font-semibold text-gray-900" data-id="element-1824" data-mp="2pmuk72whcjyt">
                {pathway.name}
              </span>
              <span className="mt-0.5 block text-xs text-gray-500" data-id="element-1825" data-mp="2gmfw5vs4sqrm">
                {pathway.organization} · {pathway.updatedLabel}
              </span>
            </span>
          </button>
        </td>
        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-700 sm:px-6" data-id="element-1826" data-mp="26o8iblt52otu">
          {LEVEL_LABELS[pathway.audience]}
        </td>
        <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-700 sm:px-6" data-id="element-1827" data-mp="2boebj6f24je1">
          {pathway.moduleIds.length}
          <span className="ml-1 text-xs text-gray-500" data-id="element-1828" data-mp="4usoyh5o2vv6">
            · {formatHours(totalHours(pathway.moduleIds))}
          </span>
        </td>
        <td className="px-3 py-4 sm:px-6" data-id="element-1829" data-mp="8fcdjwqt2aqk">
          <div className="flex items-center justify-end gap-4" data-id="element-1830" data-mp="8g4957kek8gu">
            <button type="button" onClick={() => onDuplicate(pathway)} className="flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-gray-600 transition-colors hover:text-gray-900" data-id="element-1831" data-mp="3fghqks9hpm3">
              <Copy size={14} data-id="element-1832" data-mp="3ppapz9f4nnu0" />
              Duplicate
            </button>
            <button type="button" onClick={() => onOpen(pathway)} className="flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-[#DB3725] transition-colors hover:text-[#c02f1f]" data-id="element-1833" data-mp="r4iyzrizhgg2">
              Edit
              <ArrowRight size={14} data-id="element-1834" data-mp="cfd3adjcu8cx" />
            </button>
          </div>
        </td>
      </tr>

      <AnimatePresence initial={false} data-id="element-1835" data-mp="19wtxl96lus8d">
        {expanded && <tr data-id="element-1836" data-mp="15525uvbpqggn">
            <td colSpan={4} className="border-b border-gray-100 bg-white p-0" data-id="element-1837" data-mp="154jxx1foudsw">
              <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-1838" data-mp="1ddprvneh5gnz">
                <ol className="my-2 ml-6 space-y-1.5 border-l-2 border-[#30718D]/20 pl-4 pr-3 sm:ml-10 sm:pr-6" data-id="element-1839" data-mp="1re0jisnlyza7">
                  {pathway.moduleIds.map((moduleId, index) => {
                const module = moduleById(moduleId);
                if (!module) return null;
                return <li key={moduleId} className="flex items-baseline gap-3 text-sm" data-id="element-1840" data-mp="254m3kkostf9o" data-mpi={index}>
                        <span className="w-4 flex-shrink-0 text-xs font-bold text-[#30718D]" data-id="element-1841" data-mp="2a5tegsm8mukk">
                          {index + 1}
                        </span>
                        <span className="font-medium text-gray-900" data-id="element-1842" data-mp="2k2o7wx3nm4rz">
                          {module.name}
                        </span>
                        <span className="text-xs text-gray-500" data-id="element-1843" data-mp="3bughtz14bh1h">
                          {formatHours(module.durationHours)} ·{' '}
                          {module.category}
                        </span>
                      </li>;
              })}
                </ol>
              </motion.div>
            </td>
          </tr>}
      </AnimatePresence>
    </>;
}